$(document).ready(function(){

	// -- VARS --
	
	var tlChildrenMenu = new TimelineLite({paused:true});
	var tlMainMenu = new TimelineLite({paused:true});
	var dur = 0.2;
	var delay = 0;
	var stagger = 0;
	var mainMenuItem = $('.main__menu li');


	// -- ANIMATE ON READY --
	
	if ($('.children__menu').hasClass('open')) {
		$('.main__nav').animate({
			'height': $('.children__menu.open').height()
		});
	}


	// -- OPEN ACCORDION IF CHILD ACTIVE ON READY (MAINMENU) --
	
	if ($('.mainmenu .level--3').hasClass('active')) {
		$('.mainmenu .level--3.active').parents('.nav__li.subParent').addClass('open');
		$('.main__nav').animate({
			'height': $('.children__menu.open').height()
		},0);
	}

	// -- OPEN ACCORDION IF CHILD ACTIVE ON READY (SUBMENU) --
	
	if ($('.submenu .nav__a--submenu').hasClass('active')) {
		$('body').removeClass('menu--open');
		$('.submenu .nav__a--submenu.active').parents('.nav__li.parent').addClass('open');
	}


	// -- MAIN MENU --

	$('.main__menu .nav__li.parent a').on('click', function(e){
		e.preventDefault();
		// -- Add open class to body --
		$('body').addClass('menu--open');
		
		// -- Add open class to active children menu --
		var parentID = $(this).parent('li.parent').attr('data-id');
		$('.'+parentID).addClass('open');

		// -- GSAP : Animate Children menu --
		var childrenMenu = $('.children__menu.open');
		var childrenMenuItem = $('.children__menu.open li');
		tlChildrenMenu.staggerFrom(childrenMenuItem, dur, {
			x: 50,
			opacity: 0,
		}, stagger, 0, function onCompleteAll(){
			// -- Clear inline css --
			tlChildrenMenu.set(childrenMenuItem, {clearProps:'all'});
		}).play(0.3);

		childrenMenuH = childrenMenu.height();
		$('.main__nav').animate({
			'height': childrenMenuH
		});

	});


	// -- MAIN MENU : SUBPARENT --
	
	$('.children__menu .subParent > a').on('click', function(e){
		e.preventDefault();

		// -- Toggle active class --
		$(this).parent('li.subParent').toggleClass('open');

		// -- Animate menuHeight --
		var childrenMenuH = $(this).parents('.children__menu').height();
		$('.main__nav').animate({
			'height': childrenMenuH
		});
		// if (!$(this).parent('.subParent').hasClass('open')) {
		// 	$(this).parents('.children__menu').css({
		// 		'min-height': 'inherit'
		// 	});
		// }
	});


	// -- SUB MENU --

	$('.submenu .parent > a').on('click', function(e){
		e.preventDefault();

		// -- Toggle active class --
		$(this).parent('li.parent').toggleClass('open');

	});


	// -- BACK BTN --
	$('.children__menu .back__btn').on('click', function(e){
		e.preventDefault();
		
		// -- Remove open class --
		$('.children__menu').removeClass('open');
		$('.child.subParent').removeClass('open');
		$('body').removeClass('menu--open');

		// -- GSAP : Pause animation children menu --
		tlChildrenMenu.pause();
		
		// -- GSAP : Animate main menu --
		tlMainMenu.staggerFrom(mainMenuItem, dur, {
			x: -50,
			opacity: 0,
		}, stagger, delay, function onCompleteAll(){
			// -- Clear inline css --
			tlMainMenu.set(mainMenuItem, {clearProps:'all'});
		}).play(1.3);

		mainMenuH = $('.main__menu').height();
		$('.main__nav').animate({
			'height': mainMenuH
		});

	});

	// -- HAMBURGER MENU --
	$('.menu__hamburger').on('click', function(){
		$('body').toggleClass('mobile__menu--open');
	});


	// -- CLOSE MENU --
	$('.menu__container .i--close').on('click', function(){
		$('body').removeClass('mobile__menu--open');
	});

});